import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance } from 'vue';
import IconBack from '@white-label-icon/icon-back';


export default /*#__PURE__*/_defineComponent({
  __name: 'back-button',
  props: {
    isLogout: { type: Boolean },
    buttonText: { default: 'back' }
  },
  emits: ["btnClick"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'btnClick'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isLogout?: boolean, buttonText: string };

const instance = getCurrentInstance();
const proxy = instance?.proxy as Vue;





const backButtonText = computed(() => {
  const text = `UI.buttons.${props.buttonText}`;
  return  proxy.$t?.(text) ?? text;
});

return { __sfc: true,instance, proxy, emit, props, backButtonText, IconBack }
}

})